import validate from "/usr/src/app/content/n3-spas-de3e4ec7-92ff-428b-b9bb-4d721acc7e78/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-de3e4ec7-92ff-428b-b9bb-4d721acc7e78/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}